'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import Controllable from '../decorators/Controllable';
import PropTypes from 'prop-types';
import { Component } from 'react';
import classNames from 'classnames';
import { INPUT_SIZE_OPTIONS } from './InputConstants';
import { FieldsetContext } from '../context/FieldsetContext';
var PLACEHOLDER = '__PLACEHOLDER__';

var renderOption = function renderOption(_ref) {
  var disabled = _ref.disabled,
      text = _ref.text,
      value = _ref.value,
      nestedOptions = _ref.options;
  return nestedOptions ? /*#__PURE__*/_jsx("optgroup", {
    disabled: disabled,
    label: text || value,
    children: nestedOptions.map(renderOption)
  }, text + value) : /*#__PURE__*/_jsx("option", {
    disabled: disabled,
    value: value,
    children: text || value
  }, text + value);
};

var UISelectInput = /*#__PURE__*/function (_Component) {
  _inherits(UISelectInput, _Component);

  function UISelectInput() {
    _classCallCheck(this, UISelectInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(UISelectInput).apply(this, arguments));
  }

  _createClass(UISelectInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          options = _this$props.options,
          placeholder = _this$props.placeholder,
          disabled = _this$props.disabled,
          rest = _objectWithoutProperties(_this$props, ["className", "options", "placeholder", "disabled"]);

      var fieldSize = this.context.size;
      return /*#__PURE__*/_jsx("div", {
        className: classNames("hs-custom-select private-form__control private-form__select form-control display-inline-block", INPUT_SIZE_OPTIONS[fieldSize], className, disabled && 'private-form__control--disabled'),
        children: /*#__PURE__*/_jsxs("select", Object.assign({}, rest, {
          disabled: disabled,
          children: [placeholder && /*#__PURE__*/_jsx("option", {
            disabled: true,
            value: PLACEHOLDER,
            children: placeholder
          }, "placeholder"), options.map(renderOption)]
        }))
      });
    }
  }]);

  return UISelectInput;
}(Component);

UISelectInput.contextType = FieldsetContext;
UISelectInput.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    disabled: PropTypes.bool,
    text: PropTypes.string,
    value: PropTypes.any.isRequired
  }).isRequired).isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string
};
UISelectInput.defaultProps = {
  value: PLACEHOLDER
};
UISelectInput.displayName = 'UISelectInput';
export default Controllable(UISelectInput);